export default __webpack_public_path__ + "static/media/regular_savings.241fd63a.jpg";